import { ActionType } from '../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../core/api/rsaa';
import { Endpoints } from '../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../core/api/module';
import * as R from 'ramda';


const KEY_ACTION = ActionType.LoadProjectIdRequest;
const ACTIONS    = [
  ActionType.LoadProjectIdRequest,
  ActionType.LoadProjectIdResponse,
  ActionType.LoadProjectIdError,
];


type Payload = number;

type Meta = { displayId: string; };


/**
 * Dispatch this action to get the Project ID from the server that corresponds to the given display ID
 */
export const loadProjectIdAction = (displayId: string) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ProjectId,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ displayProjectId: displayId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { displayId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, displayId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, action.meta.displayId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, action.meta.displayId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, action.meta.displayId);

  return R.assocPath(
    ['displayIdMapping', action.meta.displayId],
    payload,
    successState,
  );
};


export const loadProjectIdReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
